import _ from 'lodash'
import seedrandom from 'seedrandom'

export const doShuffle = <T,>(array: T[]) => _.shuffle(array)

// FIXME  For debug purpose, we could fix the seed
// https://stackoverflow.com/questions/76705788/how-to-seed-lodash-random-number-generator
export const doShuffleWithSeed = <T,>(array: T[], seed: string = '42') => {
    const seededLodash = seedLodash(seed)
    return seededLodash.shuffle(array)
}

// create a new lodash instance with the given seed
export const seedLodash = (seed: string) => {
    // take a snapshot of the current Math.random() fn
    const orig = Math.random
    // replace Math.random with the seeded random
    seedrandom(seed, { global: true })
    // runInContext() creates a new lodash instance using the seeded Math.random()
    // the context is a snapshot of the state of the global javascript environment, i.e. Math.random() updated to the seedrandom instance
    const lodash = _.runInContext()
    // restore the original Math.random() fn
    Math.random = orig
    // return the lodash instance with the seeded Math.random()
    return lodash
}

